<div
  class="accordion__wrapper"
  [class.accordion__wrapper--active]="this.styleState"
  #accordionWrapper
  >
  <div class="accordion__title-wrapper">
    <button
      type="button"
      class="accordion__title"
      [class.accordion__title--expanded]="active"
      [attr.aria-expanded]="active"
      [attr.data-test-id]="'accordion-toggle-' + (title() | slugify)"
      [attr.id]="slugifiedTitle()"
      (click)="openAccordion()"
      ripple="light"
			[class.accordion__title--additional-button]="
				hideAdditionalButtonOnOpen()
					? !active && additionalButton
					: additionalButton
			"
      >
      <div [innerHTML]="title()"></div>
    </button>
    @if (
      hideAdditionalButtonOnOpen()
      ? !active && additionalButton
      : additionalButton
      ) {
      <div
        class="accordion__additional-button"
        >
        <ng-container
          [ngTemplateOutlet]="additionalButton"
          [ngTemplateOutletContext]="additionalButtonContext"
          >
        </ng-container>
      </div>
    }
    <span
      class="accordion__indicator"
      [class.accordion__indicator--active]="active"
			[class.accordion__indicator--additional-button]="
				hideAdditionalButtonOnOpen()
					? !active && additionalButton
					: additionalButton
			"
      [attr.data-test-id]="'accordion-arrow-toggle-' + (title() | slugify)"
      aria-hidden="true"
      (click)="openAccordion()"
      >
      <icon glyph="chevron-down" aria-hidden="true"></icon>
    </span>
    <!--/accordion__indicator-->
  </div>
  <!--/accordion__title-->
  <div
    class="accordion__content"
    [@toggleBody]="active ? 'expanded' : 'collapsed'"
    (@toggleBody.done)="animationDone()"
    (@toggleBody.start)="animationStart()"
    >
    <div class="accordion__inline">
      @if (active) {
        <ng-template [ngTemplateOutlet]="templateRef"></ng-template>
      }
    </div>
    <!--/accordion__inline-->
  </div>
  <!--/accordion_Content-->
</div>
<!--/accordion__wrapper-->
